export default __webpack_public_path__ + "static/media/check-circle.83289b53.svg";